import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'statistics',
  initialState: { items: [] },
  reducers: {
    setItems(state, action) { state.items = action.payload; },
  }
});

export { actions as statisticsActions };
export { reducer as statisticsReducer };
